import { EStepCode } from '../../../types/form';
import { EDealTypeEx } from '../../../repositories/demand/v4/create-message';

export enum EOfferType {
  Flat = 'flat',
  Suburban = 'suburban',
  Commercial = 'commercial',
}

const objectToSkipStepMap: Record<EOfferType, EStepCode[]> = {
  [EOfferType.Flat]: [EStepCode.ObjectTypeFlat],
  [EOfferType.Suburban]: [EStepCode.ObjectTypeSuburban, EStepCode.ObjectTypeSuburbanWithLand],
  [EOfferType.Commercial]: [EStepCode.ObjectTypeCommercial, EStepCode.ObjectTypeCommercialWithBusiness],
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateSkipSteps = (formData: Record<string, any>): EStepCode[] => {
  const { dealTypeEx: dealType, offerType, objectType } = formData;

  const result = [
    dealType && EStepCode.DealTypeEx,
    offerType && EStepCode.OfferType,
    objectType && offerType && objectToSkipStepMap[offerType as EOfferType],
    dealType && [EDealTypeEx.Tenant, EDealTypeEx.Rent].includes(dealType) && EStepCode.RentType,
  ];

  return [].concat(...result).filter(Boolean) as EStepCode[];
};
